module.exports = __webpack_public_path__ + "img/Responsible Citizen.010e59c5.svg";